import { render, staticRenderFns } from "./DoinWallet.vue?vue&type=template&id=52c89f50&"
import script from "./DoinWallet.vue?vue&type=script&lang=js&"
export * from "./DoinWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports